export var expandButton = '_1efVM';
export var expandIconCircle = '$_ZGBA';
export var expandIcon = '-VuVQ';
export var expandIconRotated = '_3i9j2';
export var hideLastBorder = '_1wjKG';